/*
 * File: Typography.jsx
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on January 27, 2022 at 10:52 AM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 29, 2024 at 10:05 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './Typography.styles';


/**
 * Component
 */

export const Typography = forwardRef(({
	children, tag, variation, weight, decoration, truncate, center, fontStyle, ...rest
}, ref) => (
	<S.Typography ref={ref} as={tag} variation={variation} weight={weight} truncate={truncate} decoration={decoration} center={center} fontStyle={fontStyle} {...rest}>
		{children}
	</S.Typography>
));


/**
 * Configuration
 */

Typography.displayName = 'Typography';
Typography.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	tag: PropTypes.oneOf(['label', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span']),
	variation: PropTypes.oneOf(['1', '2', '3', 'button-small', 'button-medium']),
	weight: PropTypes.oneOf(['extralight', 'light', 'regular', 'medium', 'semibold', 'bold', 'extrabold', 'black']),
	truncate: PropTypes.bool,
	center: PropTypes.bool,
	fontStyle: PropTypes.oneOf(['italic', 'bold']),
	decoration: PropTypes.oneOf(['underline'])
};
Typography.defaultProps = {
	children: null,
	tag: 'span',
	variation: '1',
	weight: 'regular',
	truncate: false,
	center: true,
	fontStyle: null,
	decoration: null
};
